import React from 'react';

import { useMyFundraisesActivityLazyQuery } from 'generated/graphql';
import _ from 'lodash';
import {
  baseTypes,
  useLoading
} from 'modules';
import moment from 'moment';



export interface IData {
  campaigns: baseTypes.IFundraisingCampaignSummary;
}

export function useMyFundraisesActivity() {
  const [fnRunQuery, tuple] = useMyFundraisesActivityLazyQuery();

  const loading = useLoading([tuple]);

  const data = React.useMemo(() => {
    const myCampaigns = _.map(tuple.data?.myCampaigns, (campaign): baseTypes.IFundraisingCampaignSummary => ({
      id: campaign.id,
      name: campaign.name,
      creationDate: campaign.creationDate ? moment(campaign.creationDate, moment.ISO_8601) : null,
      stageDisplayName: campaign.fundingStage.displayName,
      targetCloseDate: campaign.targetCloseDate ? moment(campaign.targetCloseDate, moment.ISO_8601) : null,
      targetAmountDollars: campaign.targetAmountDollars,
      completedAt: campaign.completedAt ? moment(campaign.completedAt, moment.ISO_8601) : null,
      amountRaisedDollars: campaign.amountRaisedDollars
    }));

    const myCampaignsInProgess = _.chain(myCampaigns)
      .filter(campaign => _.isNull(campaign.completedAt))
      .orderBy(campaign => moment(campaign.creationDate).toDate(), 'desc')
      .value();

    const myCampaignsCompleted = _.chain(myCampaigns)
      .filter(campaign => !_.isNull(campaign.completedAt))
      .orderBy()
      .value();

    const sortedCampaigns = _.concat(myCampaignsInProgess, myCampaignsCompleted);

    return sortedCampaigns;

  }, [tuple.data]);

  return {
    fnRunQuery,
    loading,
    data
  };
}
